module.exports = __webpack_public_path__ + "img/zsk (11).851036fc.jpg";